/**
 * Brand-specific URLs for Terms of Use and Privacy Policy
 */

// Brand-specific Terms of Use URLs
export const TERMS_URLS: Record<string, string> = {
  valuepawn: "https://valuepawnandjewelry.com/assets/pdf/VALUEPAWN-Terms-and-Conditions.pdf",
  usapawn: "https://usapawnandjewelry.com/assets/pdf/USAPAWN-Terms-and-Conditions.pdf",
  ezpawn: "https://ezpawn.com/assets/pdf/EZPAWN-Terms-and-Conditions.pdf",
  maxpawn: "https://maxpawn.com/policies/terms-of-service",
};

// Privacy Policy URL (EZCORP default for brands without their own)
export const PRIVACY_POLICY_URL = "https://www.ezcorp.com/static-files/1fb9782c-d1a4-46c4-af67-c89578ece91b";

// Brands with their own Privacy Policy page
export const PRIVACY_POLICY_URLS: Record<string, string> = {
  maxpawn: "https://maxpawn.com/policies/privacy-policy",
};

// Family of Stores consent URL (same for all brands - EZCORP)
export const FAMILY_OF_STORES_CONSENT_URL = "https://ezpawn.com/family-of-stores/consent/";

// Instant Quote entry page path — where "Start a new quote" sends the customer
// from the saved-quote view (see SavedQuoteView usage in ez-quote.tsx). A
// same-origin relative path, not a full URL: the widget is embedded on each
// brand's own site (e.g. ezpawn.com/quote/:ezQuoteId -> ezpawn.com/online-pawn-quote),
// so this resolves correctly per brand as long as every brand site names its
// entry page the same way — unverified for brands other than ezpawn.
export const NEW_QUOTE_ENTRY_PATH = "/online-pawn-quote";

/**
 * Get Terms of Use URL for a specific brand
 * @param brand - Brand name (case-insensitive)
 * @returns Terms of Use URL
 */
export const getTermsUrl = (brand?: string): string => {
  const normalizedBrand = brand?.toLowerCase() || 'ezpawn';
  return TERMS_URLS[normalizedBrand] || TERMS_URLS.ezpawn;
};

/**
 * Get Privacy Policy URL for a specific brand
 * @param brand - Brand name (case-insensitive)
 * @returns The brand's Privacy Policy URL, or the EZCORP one
 */
export const getPrivacyPolicyUrl = (brand?: string): string => {
  return PRIVACY_POLICY_URLS[brand?.toLowerCase() ?? ''] || PRIVACY_POLICY_URL;
};

/**
 * Get Family of Stores consent URL (same for all brands)
 * @returns Family of Stores consent URL
 */
export const getFamilyOfStoresConsentUrl = (): string => {
  return FAMILY_OF_STORES_CONSENT_URL;
};

